import React from 'react';
import {Eye} from 'lucide-react';
import {resourceNoteReviewState} from '../../utils/resourceReview';

export default function NoteReviewEye({note,uid,username,role,onToggle}) {
 const state=resourceNoteReviewState(note,uid,username,role);
 const viewers=Array.isArray(note.viewers)?note.viewers:[];
 return <div className="eye-button-wrapper"><button type="button" className={'note-reviewed-btn '+(state.viewed?'viewed':state.relevant?'tagged-unreviewed':'')} aria-pressed={state.viewed} aria-label={state.viewed?'Mark note unread':'Mark note reviewed'} title={state.viewed?'Reviewed by you':state.relevant?'Relevant to you · not reviewed':'Mark as reviewed'} onClick={()=>onToggle(note)}><Eye size={17} aria-hidden="true"/></button><div className="eye-tooltip">{viewers.length?viewers.join(', '):'No one has reviewed yet'}</div></div>;
}
